import React from 'react';
import {
  languageBadge,
  languageName,
  nativeLanguageName,
} from '../../utils/languageName';
import styles from './LanguageSwitcher.module.css';

interface LanguageChoicesProps {
  locales: string[];
  /** `menuitem` inside the switcher's menu; plain buttons on the Pick screen. */
  itemRole?: 'menuitem';
  /** A switch is in flight: rows stay focusable (so focus is not lost) but do nothing. */
  disabled?: boolean;
  onChoose: (locale: string) => void;
}

/** The languages a learner can add (or pick first): badge, English name and the name in the language itself. */
export const LanguageChoices: React.FC<LanguageChoicesProps> = ({
  locales,
  itemRole,
  disabled,
  onChoose,
}) => (
  <>
    {locales.map((locale) => {
      const native = nativeLanguageName(locale);
      return (
        <button
          key={locale}
          type="button"
          role={itemRole}
          tabIndex={itemRole ? -1 : undefined}
          className={styles.choice}
          aria-disabled={disabled || undefined}
          onClick={() => onChoose(locale)}
        >
          <span className={styles.code} aria-hidden="true">
            {languageBadge(locale)}
          </span>
          <span>
            {languageName(locale)}
            {native !== languageName(locale) && (
              <small lang={locale.split(/[-_]/)[0]}>{native}</small>
            )}
          </span>
        </button>
      );
    })}
  </>
);

export default LanguageChoices;
